import React from 'react';
import moment from "moment";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Combobox from 'react-widgets/lib/Combobox';
import 'react-widgets/dist/css/react-widgets.css';
import {FilePond} from 'react-filepond';
import 'filepond/dist/filepond.min.css';

export default class Form extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: true,
            status: 0,
            currentSection: 0,
            currentItem: 0,
            formData: {
                formID: this.props.id,
                formName: "",
                formDescription: "",
                formSections: []
            },
            responses: {
                
            }
        }
    }
    componentDidMount()
    {
        this.loadForm();
    }
    loadForm()
    {
        this.setState({loaded: false}, () => {
            this.props.api.send({
                controller: "Form",
                action: "GetForm",
                method: "post",
                body: JSON.stringify({formID: this.props.id}),
                success: (result) => {
                    console.log(result);
                    // Randomize results if form items are set as random.
                    var form = result.form;
                    for(let s = 0; s < form.formSections.length; s++){
                        var section = form.formSections[s];
                        if(section.randomize === true){
                            for (let i = section.formItems.length - 1; i > 0; i--) {
                                const j = Math.floor(Math.random() * (i + 1));
                                [section.formItems[i], section.formItems[j]] = [section.formItems[j], section.formItems[i]];
                            }
                        }
                    }
                    this.setState({
                        loaded: true,
                        formData: result.form
                    });
                },
                error: (err) => {
                    this.setState({loaded: true});
                }
            })
        });
    }

    incrementStatus()
    {
        let status = this.state.status;
        status++;
        this.setState({status: status});
    }
    incrementSection()
    {
        let currentSection = this.state.currentSection;
        currentSection++;
        if(this.state.currentSection >= (this.state.formData.formSections.filter(x => !x.admin).length -1)){
            this.completeForm();
        }
        this.setState({currentSection: currentSection});
    }
    incrementItem()
    {
        let currentItem = this.state.currentItem;
        currentItem++;
        if (this.state.formData.formSections[this.state.currentSection].formItems.length === currentItem)
        {
            currentItem = 0;
            this.incrementSection();
        }
        this.setState({currentItem: currentItem});
    }

    completeSectionItem(e, index, itemType){
        let form = this.state.formData;
        if(index >= 0){
            form.formSections[this.state.currentSection].formItems[index].itemValue = (
                itemType === 0 ? e.target.value 
                : itemType === 1 ? e.target.nextSibling.wholeText.trim()
                : itemType === 2 ? e.target.value 
                : itemType === 3 ? e._d
                : itemType === 6 ? e.target.nextSibling.wholeText.trim()
                : itemType === 7 ? e.target.value
                : itemType === 9 ? e.target.value: ""
            );
        }
        this.setState({formData: form});
    }

    completeExtensibleListItem(e, index)
    {
        let form = this.state.formData;
        if(e.itemText === undefined)   
            form.formSections[this.state.currentSection].formItems[index].itemValue = e;
        else
            form.formSections[this.state.currentSection].formItems[index].itemValue = e.itemText;
        
        this.setState({formData: form});
    }
    
    completeSectionDropDownItem(e, index, itemType){
        let form = this.state.formData;
        if(index >= 0){
            form.formSections[this.state.currentSection].formItems[index].itemDropDownItemID = e.target.value;
        }
        this.setState({formData: form});
    }

    completeSectionItemListItem(e, index, itemIndex, itemType){
        let form = this.state.formData;
        let item = form.formSections[this.state.currentSection].formItems[index];
        if(!item.itemValues)
            item.itemValues = [];

        if(index >= 0){
            let listItem = item.itemList[itemIndex];
            let listItemID = listItem.listItemID
            
            if(item.itemType === 4) // Clear Exclusive.
                item.itemList.map(i => i.itemSelected = false);
            item.itemList[itemIndex].itemSelected = e.target.checked;
            if(e.target.checked){
                if(itemType === 4){ // Exclusive list
                    item.itemValues = [listItemID];
                    if(listItem.itemType !== 2){
                        item.itemMeta = ""; // Purge item meta if other(2) is not selected (exclusive).
                    }
                }else{
                    item.itemValues.push(listItemID);
                }
            }else{
                if(listItem.itemType === 2){
                    item.itemMeta = ""; // Purge item meta if other(2) is unchecked.
                }
                // remove from values if present. 
                let values = item.itemValues
                values.splice(values.indexOf(listItemID), 1);
                item.itemValues = values;
            }
        }
        this.setState({formData: form});
    }

    setItemMeta(e, sectionidx, itemidx)
    {
        let form = this.state.formData;
        form.formSections[sectionidx].formItems[itemidx].itemMeta = e.target.value;
        this.setState({fomrData: form});
    }

    addItemFiles(error, file, itemidx){
        let form = this.state.formData;
        let item = form.formSections[this.state.currentSection].formItems[itemidx];
        if(file.file !== null){
            var sendFile = file.file;
            let f = new FormData();
            f.append("File", sendFile)
            f.append("attachmentType",2);
            this.props.api.send({
                controller: "Form",
                action: "SaveFormItemFile",
                headers: {'Content-Type': 'multipart/form-data'},
                method: "post",
                body: f,
                fileUpload: true,
                success: (result) => {
                    if(result.success === true){
                        var attachmentID = result.attachmentID;
                        item.itemFileName = sendFile.name;
                        item.itemAttachmentID = attachmentID;
                        item.attachments = [sendFile];
                        this.setState({formData: form})
                    }
                },
                error: (result) => { 
                    //swallow
                }
            });
        }
    }
    updateItemFiles(e, itemidx){
        let form = this.state.formData;
        let item = form.formSections[this.state.currentSection].formItems[itemidx];
        if(e.length === 0){
            item.itemFileName = "";
            item.itemAttachmentID = null;
            item.attachments = [];
            this.setState({formData: form})
        }
    }
    completeForm(){
        // Take form data from state and send it to API
        this.setState({loaded: false}, () => {
            this.props.api.send({
                controller: "Form",
                action: "SubmitForm",
                method: "post",
                body: JSON.stringify(this.state.formData),
                success: (result) => {
                    console.log(result);
                    if(result.success === true){
                        this.setState({
                            loaded: true
                        });
                    }
                },
                error: (err) => {
                    this.setState({loaded: true});
                }
            })
        });
    }

    render()
    {
        const formData = this.state.formData;
        const currentSection = this.state.currentSection;
        const currentItem = this.state.currentItem;
        return this.state.loaded ? (
            <div className="lmsdisplayarea">
                {this.state.status === 0 ? (
                    <div>
                        <h3>{formData.formName}</h3>
                        <p>
                            {formData.formDescription}
                        </p>
                        <input type="button" className="lmsbutton" value="Start Form" onClick={() => this.incrementStatus()} />
                    </div>
                ) : formData.formSections.length -1 >= currentSection && !formData.formSections[currentSection].admin ? (
                    <div>
                        <h3>{formData.formName}</h3>
                        <div className="lmsform">
                            <div className="lmsformheading">
                                {formData.formSections[currentSection].name}
                            </div>
                            <div className="lmsformbody" style={{color: "#222222"}}>
                                <div className="lmsforminner">
                                    <p>{formData.formSections[currentSection].description}</p>
                                    {formData.formSections[currentSection].single ? (
                                        <div>
                                            {formData.formSections[currentSection].formItems.length -1 >= currentItem ? (
                                                <div>
                                                    {formData.formSections[currentSection].formItems[currentItem].itemType !== 6 ? (
                                                        <label>{formData.formSections[currentSection].formItems[currentItem].itemText}</label>
                                                    ): null}
                                                    <div style={{marginTop: "10px", marginBottom: "10px"}}>
                                                        {formData.formSections[currentSection].formItems[currentItem].itemType === 0 ? (
                                                            <input type="text" className="lmsforminput" 
                                                            name={"formText_" + formData.formSections[currentSection].formItems[currentItem].itemID}
                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                            value={formData.formSections[currentSection].formItems[currentItem].itemValue} 
                                                            onChange={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                            />
                                                        ) :
                                                        formData.formSections[currentSection].formItems[currentItem].itemType === 1 ? (
                                                            <div>
                                                                <div className="form-radiobutton-container">
                                                                    <div className="lmsradiobuttons">
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + formData.formSections[currentSection].formItems[currentItem].itemID}  
                                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID}
                                                                            onClick={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                                            checked={formData.formSections[currentSection].formItems[currentItem].itemValue === "OK"}
                                                                            /> OK
                                                                        </label>
                                                                    </div>
                                                                    <div className="lmsradiobutton">
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID}
                                                                            onClick={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                                            checked={formData.formSections[currentSection].formItems[currentItem].itemValue === "Repairs Required"}
                                                                            /> Repairs Required
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {formData.formSections[currentSection].formItems[currentItem].itemValue === "Repairs Required" ? (
                                                                    <div>
                                                                        <textarea name={"formMeta_" + formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                                            value={formData.formSections[currentSection].formItems[currentItem].itemMeta}
                                                                            onChange={(e, index, itemIndex) => this.setItemMeta(e, currentSection, currentItem)}
                                                                            className="lmstextarea" style={{width: "100%", marginTop: "10px"}} 
                                                                        />
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 2 ? (
                                                            <textarea type="text" className="lmsforminput" 
                                                            name={"formTextArea_" + formData.formSections[currentSection].formItems[currentItem].itemID}
                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                            value={formData.formSections[currentSection].formItems[currentItem].itemValue} 
                                                            onChange={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                            style={{width: "100%", height: "110px"}}
                                                            />
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 3 ? ( 
                                                            <DatePicker showTimeSelect name={this.props.name}
                                                                className="lmsforminput"
                                                                timeFormat="HH:mm" dateFormat="MM/DD/YYYY HH:mm"
                                                                id={formData.formSections[currentSection].formItems[currentItem].itemID.toString()} 
                                                                timeIntervals={5}
                                                                selectsStart
                                                                selected={formData.formSections[currentSection].formItems[currentItem].itemValue !== ''? moment(formData.formSections[currentSection].formItems[currentItem].itemValue) : null}
                                                                startDate={formData.formSections[currentSection].formItems[currentItem].itemValue !== ''? moment(formData.formSections[currentSection].formItems[currentItem].itemValue) : null}
                                                                onChange={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                            />
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 4 ? ( 
                                                            <div className="form-radiobutton-container">
                                                                {formData.formSections[currentSection].formItems[currentItem].itemList.map((listItem, listItemIdx) =>
                                                                    <div key={listItemIdx} className="lmsradiobutton">
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + formData.formSections[currentSection].formItems[currentItem].itemID}  
                                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID}
                                                                            onChange={(e, index, itemIndex, itemType) => this.completeSectionItemListItem(e, currentItem, listItemIdx, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                                            checked={formData.formSections[currentSection].formItems[currentItem].itemValues.indexOf(listItem.listItemID) >= 0}
                                                                            /> {listItem.itemText}
                                                                        </label>
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    {(formData.formSections[currentSection].formItems[currentItem].itemList.filter((i) => i.itemType === 2 && i.itemSelected === true ).length > 0) ? (
                                                                        <div>
                                                                            <textarea name={"formMeta_" + formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                                                value={formData.formSections[currentSection].formItems[currentItem].itemMeta}
                                                                                onChange={(e, sectionidx, itemIndex) => this.setItemMeta(e, currentSection, currentItem)}
                                                                                className="lmstextarea" style={{width: "365px", marginTop: "10px"}} />
                                                                        </div>
                                                                    ): null}
                                                                </div>
                                                            </div>
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 5 ? ( 
                                                            <div>
                                                                {formData.formSections[currentSection].formItems[currentItem].itemList.map((listItem, listItemIdx) =>
                                                                    <div key={listItemIdx} className="lmsradiobutton">
                                                                        <label>
                                                                            <input type="checkbox" 
                                                                            name={"formChk_" + formData.formSections[currentSection].formItems[currentItem].itemID}  
                                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID}
                                                                            onChange={(e, index, itemIndex, itemType) => this.completeSectionItemListItem(e, currentItem, listItemIdx, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                                            checked={formData.formSections[currentSection].formItems[currentItem].itemValues.indexOf(listItem.listItemID) >= 0}
                                                                            /> {listItem.itemText}
                                                                        </label>
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    {(formData.formSections[currentSection].formItems[currentItem].itemList.filter((i) => i.itemType === 2 && i.itemSelected === true ).length > 0) ? (
                                                                        <div>
                                                                            <textarea name={"formMeta_" + formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                                                value={formData.formSections[currentSection].formItems[currentItem].itemMeta}
                                                                                onChange={(e, sectionidx, itemIndex) => this.setItemMeta(e, currentSection, currentItem)}
                                                                                className="lmstextarea" style={{width: "365px", marginTop: "10px"}} />
                                                                        </div>
                                                                    ): null}
                                                                </div>
                                                            </div>
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 6 ? ( 
                                                            <div className="lmsformitem">
                                                                <iframe src={formData.formSections[currentSection].formItems[currentItem].itemFilePreview} 
                                                                    type="application/pdf" width="100%" height="600px" title="Form Item" ></iframe>
                                                                <div className="lmsradiobutton">
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID}
                                                                            onClick={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                                            checked={formData.formSections[currentSection].formItems[currentItem].itemValue === "Agree"}
                                                                            /> Agree
                                                                        </label>
                                                                        
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID}
                                                                            onClick={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                                            checked={formData.formSections[currentSection].formItems[currentItem].itemValue === "Disagree"}
                                                                            /> Disagree
                                                                        </label>
                                                                </div>
                                                            </div>
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 7 ? ( 
                                                            <select className="lmsforminput form-dropdown-container" name={"formDD_" + formData.formSections[currentSection].formItems[currentItem].itemID}  value={formData.formSections[currentSection].formItems[currentItem].itemDropDowmItemID}
                                                            onChange={(e, index, itemType) => this.completeSectionDropDownItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} >
                                                                {formData.formSections[currentSection].formItems[currentItem].itemDropDownList.listItems.map(li =>
                                                                    <option key={li.itemID} value={li.itemID}>{li.name}</option>
                                                                )}        
                                                            </select>
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 8 ? ( 
                                                            <div>
                                                                <Combobox data={formData.formSections[currentSection].formItems[currentItem].itemList} 
                                                                    name={"combobox_" + formData.formSections[currentSection].formItems[currentItem].itemID}
                                                                    textField="itemText"
                                                                    valueField="itemValue"
                                                                    suggest={true}
                                                                    autoFocus={true}
                                                                    onChange={(e, index) => this.completeExtensibleListItem(e, currentItem)}/>
                                                            </div>
                                                        ) : formData.formSections[currentSection].formItems[currentItem].itemType === 9 ? (  
                                                            <input type="text" className="lmsforminput-signature" 
                                                            name={"formText_" + formData.formSections[currentSection].formItems[currentItem].itemID}
                                                            id={formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                            value={formData.formSections[currentSection].formItems[currentItem].itemValue}
                                                            onChange={(e, index, itemType) => this.completeSectionItem(e, currentItem, formData.formSections[currentSection].formItems[currentItem].itemType)} 
                                                            />
                                                        ) : null}
                                                        <div className="lmsformitem" style={{padding: "5px"}}>
                                                            {formData.formSections[currentSection].formItems[currentItem].attachment === true ? (
                                                                <FilePond 
                                                                    ref={ref => this.pond = ref}
                                                                    files={formData.formSections[currentSection].formItems[currentItem].attachments}
                                                                    maxFiles={1}
                                                                    onupdatefiles= {(e, index) => this.updateItemFiles(e, currentItem)}
                                                                    onaddfile= {(error, file) => this.addItemFiles(error, file, currentItem)}
                                                                />
                                                            ): null }
                                                        </div>
                                                    </div>
                                                    {
                                                    (formData.formSections[currentSection].formItems[currentItem].itemType !== 6 &&
                                                    formData.formSections[currentSection].formItems[currentItem].itemType !== 1) || (
                                                    formData.formSections[currentSection].formItems[currentItem].itemValue === "OK" ||
                                                    formData.formSections[currentSection].formItems[currentItem].itemValue === "Agree" ||
                                                     (formData.formSections[currentSection].formItems[currentItem].itemValue === "Repairs Required" &&
                                                        formData.formSections[currentSection].formItems[currentItem].itemMeta !== "" &&
                                                            formData.formSections[currentSection].formItems[currentItem].itemMeta !== undefined)) ? (
                                                        <input type="button" className="lmsbutton" value="Next" onClick={() => this.incrementItem()} />
                                                    ) : null}
                                                </div>
                                            ) : (
                                                <div>
                                                    Section complete.
                                                    <input type="button" className="lmsbutton" value="Next Section" onClick={() => this.incrementSection()} />
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            {formData.formSections[currentSection].formItems.map((item, itemidx )=>
                                                <div style={{fontWeight: "bold"}} key={item.itemID}>
                                                    <hr></hr>
                                                    <div className="lmsformitem">
                                                        <label className="lmsformlabel">{item.itemText}</label>
                                                        {item.itemType === 0 ? (
                                                            <input type="text" className="lmsforminput" 
                                                            name={"formText_" + item.itemID}
                                                            id={item.itemID} 
                                                            value={item.itemValue}
                                                            onChange={(e, index, itemType) => this.completeSectionItem(e, itemidx, item.itemType)} 
                                                            />
                                                        ) : item.itemType === 1 ? (
                                                            <div>
                                                            <div className="form-radiobutton-container">
                                                                <div className="lmsradiobuttons">
                                                                    <label>
                                                                        <input type="radio" 
                                                                        name={"formRbtn_" + item.itemID} 
                                                                        onClick={(e, index, itemType) => this.completeSectionItem(e, itemidx, item.itemType)} 
                                                                        checked={item.itemValue === "OK"}
                                                                        /> OK
                                                                    </label>
                                                                </div>
                                                                <div className="lmsradiobutton">
                                                                    <label>
                                                                        <input type="radio" 
                                                                        name={"formRbtn_" + item.itemID} 
                                                                        onClick={(e, index, itemType) => this.completeSectionItem(e, itemidx, item.itemType)} 
                                                                        checked={item.itemValue === "Repairs Required"}
                                                                        /> Repairs Required
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            {item.itemValue === "Repairs Required" ? (
                                                                <div>
                                                                    <textarea name={"formMeta_" + item.itemID} 
                                                                        value={item.itemMeta}
                                                                        onChange={(e, sectionidx, itemIndex) => this.setItemMeta(e, currentSection, itemidx)}
                                                                        className="lmstextarea" style={{width: "100%", marginTop: "10px"}} />
                                                                </div>
                                                            ) : null}
                                                            </div>
                                                        ) : item.itemType === 2 ? (
                                                            <textarea type="text" className="lmsforminput" 
                                                            name={"formTextArea_" + item.itemID}
                                                            id={item.itemID} 
                                                            value={item.itemValue} 
                                                            onChange={(e, index, itemType) => this.completeSectionItem(e, itemidx, item.itemType)} 
                                                            />
                                                        ) : item.itemType === 3 ? ( 
                                                            <DatePicker showTimeSelect name={this.props.name}
                                                                className="lmsforminput"
                                                                timeFormat="HH:mm" dateFormat="MM/DD/YYYY HH:mm"
                                                                id={item.itemID} 
                                                                timeIntervals={5}
                                                                selected={item.itemValue !== ''? moment(item.itemValue) : null}
                                                                startDate={item.itemValue !== ''? moment(item.itemValue) : null}
                                                                onChange={(e, index, itemType) => this.completeSectionItem(e, itemidx, item.itemType)} 
                                                            />
                                                        ) : item.itemType === 4 ? ( 
                                                            <div className="form-radiobutton-container">
                                                                {item.itemList.map((listItem, listItemIdx) =>
                                                                    <div key={listItemIdx} className="lmsradiobutton">
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + item.itemID}  
                                                                            id={item.itemID}
                                                                            onChange={(e, index, itemIndex, itemType) => this.completeSectionItemListItem(e, itemidx, listItemIdx, item.itemType)} 
                                                                            checked={listItem.itemSelected === true}
                                                                            /> {listItem.itemText}
                                                                        </label>
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    {(item.itemList.filter((i) => i.itemType === 2 && i.itemSelected === true ).length > 0) ? (
                                                                        <div>
                                                                            <textarea name={"formMeta_" + formData.formSections[currentSection].formItems[itemidx].itemID} 
                                                                                value={formData.formSections[currentSection].formItems[itemidx].itemMeta}
                                                                                onChange={(e, sectionidx, itemIndex) => this.setItemMeta(e, currentSection, itemidx)}
                                                                                className="lmstextarea" style={{width: "365px", marginTop: "10px"}} />
                                                                        </div>
                                                                    ): null}
                                                                </div>
                                                            </div>
                                                        ) : item.itemType === 5 ? ( 
                                                            <div className="form-radiobutton-container">
                                                                {item.itemList.map((listItem, listItemIdx) =>
                                                                <div key={listItemIdx} className="lmsradiobutton">
                                                                    <label>
                                                                        <input type="checkbox" 
                                                                        name={"formChk_" + item.itemID}  
                                                                        id={item.itemID}
                                                                        onChange={(e, index, itemIndex, itemType) => this.completeSectionItemListItem(e, itemidx, listItemIdx, item.itemType)} 
                                                                        checked={listItem.itemSelected}
                                                                        /> {listItem.itemText}
                                                                    </label>
                                                                </div>
                                                                )}
                                                                <div>
                                                                    {(item.itemList.filter((i) => i.itemType === 2 && i.itemSelected === true ).length > 0) ? (
                                                                        <div>
                                                                            <textarea name={"formMeta_" + formData.formSections[currentSection].formItems[currentItem].itemID} 
                                                                                value={formData.formSections[currentSection].formItems[itemidx].itemMeta}
                                                                                onChange={(e, sectionidx, itemIndex) => this.setItemMeta(e, currentSection, itemidx)}
                                                                                className="lmstextarea" style={{width: "365px", marginTop: "10px"}} />
                                                                        </div>
                                                                    ): null}
                                                                </div>
                                                            </div>
                                                        ) : item.itemType === 6 ? ( 
                                                            <div className="lmsformitem">
                                                                <iframe src={item.itemFilePreview} type="application/pdf" width="100%" height="600px" title="Form Item" ></iframe>
                                                                <div className="lmsradiobutton">
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + item.itemID} 
                                                                            id={item.itemID}
                                                                            onClick={(e, index, itemType) => this.completeSectionItem(e, currentItem, item.itemType)} 
                                                                            checked={item.itemValue === "Agree"}
                                                                            /> Agree
                                                                        </label>
                                                                        
                                                                        <label>
                                                                            <input type="radio" 
                                                                            name={"formRbtn_" + item.itemID} 
                                                                            id={item.itemID}
                                                                            onClick={(e, index, itemType) => this.completeSectionItem(e, currentItem, item.itemType)} 
                                                                            checked={item.itemValue === "Disagree"}
                                                                            /> Disagree
                                                                        </label>
                                                                </div>
                                                            </div>
                                                        ) : item.itemType === 7 ? ( 
                                                                <select className="lmsforminput form-dropdown-container" name={"formDD_" + item.itemID}  value={item.itemDropDowmItemID}
                                                                onChange={(e, index, itemType) => this.completeSectionDropDownItem(e, itemidx, item.itemType)} >
                                                                    {item.itemDropDownList.listItems.map(li =>
                                                                        <option key={li.itemID} value={li.itemID}>{li.name}</option>
                                                                    )}        
                                                                </select>
                                                        ) : item.itemType === 8 ? ( 
                                                            <div>
                                                                <Combobox data={item.itemList} 
                                                                    name={"combobox_" + item.itemID}
                                                                    textField="itemText"
                                                                    valueField="itemValue"
                                                                    suggest={true}
                                                                    autoFocus={true}
                                                                    onChange={(e, index) => this.completeExtensibleListItem(e, itemidx)}
                                                                    />
                                                            </div>
                                                        ) : item.itemType === 9 ? ( 
                                                                <input type="text" className="lmsforminput-signature" 
                                                                name={"formText_" + item.itemID}
                                                                id={item.itemID} 
                                                                value={item.itemValue}
                                                                onChange={(e, index, itemType) => this.completeSectionItem(e, itemidx, item.itemType)} 
                                                                />
                                                        ) : null}
                                                        {item.attachment === true ? (
                                                            <FilePond 
                                                                ref={ref => this.pond = ref}
                                                                files={item.attachments}
                                                                maxFiles={1}
                                                                onupdatefiles= {(e, index) => this.updateItemFiles(e, itemidx)}
                                                                onaddfile= {(error, file) => this.addItemFiles(error, file, itemidx)}
                                                            />
                                                        ): null }
                                                    </div>
                                                </div>
                                            )}
                                            <div className="lmscenter">
                                                <input type="button" className="lmsbutton" value="Next" onClick={() => this.incrementSection()} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <strong>Form complete.</strong>
                    </div>
                )}
            </div>
        ) : (
            <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/forms/form.js